import * as React from 'react'

interface Props {
  notes: string[]
  warn?: boolean
}

const Component: React.FC<Props> = ({ notes, warn }) => (
  <div className="mt-1">
    {notes.map((note, index) => (
      <div key={index} className={`note${warn ? ' text-danger' : ''}`}>
        {note}
      </div>
    ))}
  </div>
)

export default Component
